var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":_vm.receive}},[_c('translate',{attrs:{"source":"Receive"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }